import { AlertTriangle } from "lucide-react";
import Modal from "./Modal";

export default function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = "Confirmar", danger = false }) {
  return (
    <Modal open={open} onClose={onClose} title={title || "Confirmação"} w={420}>
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 18 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 8,
          background: danger ? "#fef2f2" : "#f0fdfa",
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <AlertTriangle size={18} color={danger ? "#ef4444" : "#f59e0b"} />
        </div>
        <div style={{ fontSize: 13, color: "#475569", lineHeight: 1.5, paddingTop: 4 }}>
          {message}
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button
          onClick={onClose}
          style={{
            padding: "8px 16px", borderRadius: 7,
            border: "1px solid #e2e8f0", background: "#fff",
            color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer",
          }}
        >
          Cancelar
        </button>
        <button
          onClick={() => { onConfirm(); onClose(); }}
          style={{
            padding: "8px 16px", borderRadius: 7, border: "none",
            background: danger ? "#ef4444" : "#0d9488",
            color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer",
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
